






























import {Component} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import Query from '../../../components/query/queryHeard.vue'
import {QueryManufacturer} from '../../../api/basicDictionary'
import {QueryTenant} from '../../../api/shipmentsManagement'
import myform from '../../../components/form/index.vue'
import {
    GetMachineMaintenanceList,
    GetMachineRepairList,
    GetMachineScrapList,
    GetMachineTypeList
} from "@/api/machines"
import Repair from './parts/repair.vue'

@Component({
    components: {myTable, myform, Query, Repair}
})
export default class extends AbpBase {
    model: any = {
        MachineName: '',
        Source: null,
        TenantId: null,
        MachineNo: '',
        Manufacturer: ''
    }
    list: Array<object> = []
    formShow: boolean = false
    formTitle: string = ''
    formData: object = {}
    formItem: Array<any> = []
    tenants: Array<any> = []
    types: Array<any> = []
    manufacturers: Array<any> = []
    sources: Array<any> = [
        {value: 1, text: '集团'},
        {value: 2, text: '中心'}
    ]

    conditions: any = []

    //获取条件下拉框
    async getSelects() {
        this.tenants = ((await QueryTenant({queryString: '', pageSize: 10000, page: 1})).data).map((item: any) => {
            return {
                value: item.tenantId,
                text: item.name,
            }
        })
        this.manufacturers = ((await QueryManufacturer({
            queryString: '',
            pageSize: 10000,
            page: 1
        })).data.items).map((item: any) => {
            return {
                value: item.name,
                text: item.name,
            }
        })
        this.types = ((await GetMachineTypeList({
            status: true,
            page: 1,
            pageSize: 10000
        })).items).map((item: any) => {
            return {
                value: item.id,
                text: item.machineTypeName,
            }
        })
        this.conditions = [
            {
                name: 'MachineName',
                dataType: 1,
                value: this.model.MachineName,
                label: '设备名称',
            },
            {
                name: 'TenantId',
                dataType: 6,
                value: this.model.TenantId,
                label: '中心',
                options: this.tenants
            },
            {
                name: 'Manufacturer',
                dataType: 1,
                value: this.model.Manufacturer,
                label: '生产厂家',
            },
            {
                name: 'Source',
                dataType: 6,
                value: this.model.Source,
                label: '来源',
                options: this.sources
            },
            {
                name: 'MachineNo',
                dataType: 1,
                value: this.model.MachineNo,
                label: '设备编号',
            },
        ]
    }

    async created() {
        await this.getSelects()
        this.getData()
    }

    async getData() {
        this.table.loading = true
        let search = {}
        this.conditions.forEach((item: any) => {
            if (item.value)
                search[item.name] = item.value
        })
        let res = await GetMachineScrapList({...search, ...this.table})
        this.list = res.items;
        this.table.totalCount = res.totalCount
        this.table.loading = false
    }
    saveSuccess(){
        this.formShow=false;
        this.getData()
    }
    pageChange(page: number) {
        this.table.page = page
        this.getData();
    }

    pagesizeChange(pagesize: number) {
        this.table.pageSize = pagesize
        this.getData();
    }

    async addOrEdit(row: object) {
        this.formTitle = !row ? '新增' : '编辑'
        this.formData = {
            name: '',
            pinYin: '',
            wubi: '',
            isActive: true,
        }
        this.formData = Object.assign(this.formData, row)
        this.formShow = true
    }

    columns: Array<any> = [
        {title: "中心", key: "dialysisCenterName"},
        {title: "设备名称", key: "machineName"},
        {title: "设备编号", key: "machineNo"},
        {title: "设备型号", key: "machineModel"},
        {title: "制造商（生产厂家）", key: "manufacturer"},
        {title: "报废原因", key: "scrapInfo"},
        {
            title:'操作',
            width:'80',
            render:(h:any,p:any)=>{
                return h('el-button',{
                    props:{
                        type:'text',
                        size:'small'
                    },
                    directives:[{
                        name:'allow'
                    }],
                    on:{
                        click:()=>{
                            this.addOrEdit(p.row)
                        }
                    }
                },'编辑')
            }
        },
    ]
}
